module.exports = __webpack_public_path__ + "img/mp1.7b90384c.jpg";